import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";

import { FormField } from "../../../../sharedComponents/formField";
import {
	mainStatusList,
	timeAndServeList,
	franchiseRegionList,
	servingsFieldList
} from "../../../../constants/recipeConstants";
import { required, max64, array } from "../../../../constants/formValidators";
import { saveBasicDetails, updateBasicDetails } from "../../../../store/actions";

const BasicDetails = ({
	setActiveTab,
	handleSubmit,
	saveBasicDetails,
	updateBasicDetails,
	initialValues,
	history,
	resetForm
}) => {
	const [submitting, setSubmitting] = useState(false);

	const validateForm = (values) => {
		const successHandler = (res) => {
			res.json().then((data) => {
				history.push(`/nutrition/recipes/${data.id}/add`);
				setActiveTab(1);
				setSubmitting(false);
			});
		};
		setSubmitting(true);
		if (initialValues && initialValues.id) {
			if (initialValues === values) {
				setActiveTab(1);
				setSubmitting(false);
			} else {
				updateBasicDetails(values, successHandler);
			}
		} else {
			saveBasicDetails(values, successHandler);
		}
	};

	const enable = () => {
		setSubmitting(false);
	};

	return (
		<form onSubmit={handleSubmit(validateForm)} className="p-4">
			<p>
				Public Recipes must keep the name to less than 30 characters to fit on Medi-Weightloss&reg; Home Page as Public
			</p>
			<div className="row">
				{mainStatusList.map(({ label, name }, index) => {
					return (
						<Field
							key={index}
							label={label}
							name={name}
							type="checkbox"
							formGroupClass="col-2"
							component={FormField}
							onChange={enable}
						/>
					);
				})}
			</div>
			<h4 className="mt-3">Franchise region</h4>
			<div className="row">
				<Field
					options={franchiseRegionList}
					name="franchise_region"
					type="checkboxGroup"
					formGroupClass="col-12"
					checkboxGroupClass="col-2"
					component={FormField}
					validate={[required, array]}
					onChange={enable}
				/>
			</div>
			<div className="row">
				<Field
					label="Recipe Name"
					name="name"
					type="text"
					validate={[required, max64]}
					formGroupClass="col-6"
					component={FormField}
					onChange={enable}
				/>
			</div>
			<div className="row">
				{timeAndServeList.map((input, index) => {
					return <Field key={index} formGroupClass="col-2" component={FormField} {...input} onChange={enable} />;
				})}
			</div>
			<h4 className="mt-3">Servings</h4>
			<div className="row">
				{servingsFieldList.map((input, index) => {
					return <Field key={index} formGroupClass="col-2" component={FormField} {...input} onChange={enable} />;
				})}
			</div>
			<div className="row">
				<div className="col-8 form-group">
					<Field
						name="directions"
						label="Directions"
						type="textarea"
						component={FormField}
						className="form-control"
						validate={[required]}
						onChange={enable}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-8 form-group">
					<Field
						name="notes"
						label="Notes"
						type="textarea"
						component={FormField}
						className="form-control"
						onChange={enable}
					/>
				</div>
			</div>
			<div className="tab-footer row pt-3">
				<div className="col-12 text-right">
					<button className="btn btn-default" type="button" onClick={() => resetForm("BasicDetails")}>
						Reset
					</button>
					<button className="btn btn-primary-dark" type="submit" disabled={submitting}>
						Save &amp; Next
					</button>
				</div>
			</div>
		</form>
	);
};

const mapDispatchToProps = {
	saveBasicDetails,
	updateBasicDetails,
	resetForm: reset
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "BasicDetails",
		enableReinitialize: true
	})(BasicDetails)
);
